import {createSlice} from '@reduxjs/toolkit';

export const questionsSlice = createSlice({
  name: 'questions',
  initialState: {
    selectedQuestion: 'Q11',
    selectedQuestionNumber: 0,
    selectedQuestionSubquestions: [
      {vPay: {vlang: ''}},
      {vPay: {vlang: ''}},
      {vPay: {vlang: ''}},
      {vPay: {vlang: ''}},
    ],
    selectedQuestionSubquestionsNumber: {v: 'Q_11'},
    selectedQuestionSubQKeys: ['Q11'],
    filteredResponses: [{}],
    selectedQuestionV: 'Q11',
    totalQuestionResponses: '',
    selectedNote: '',
    isLoading: false,
    hasResponse: false,
  },
  reducers: {
    selectedQuestion: (state, action) => {
      state.selectedQuestion = action.payload;
    },
    selectedQuestionNumber: (state, action) => {
      state.selectedQuestionNumber = action.payload;
    },
    selectedQuestionSubquestions: (state, action) => {
      state.selectedQuestionSubquestions = action.payload;
    },
    selectedQuestionSubquestionsNumber: (state, action) => {
      state.selectedQuestionSubquestionsNumber = action.payload;
    },
    selectedQuestionResponses: (state, action) => {
      state.selectedQuestionResponses = action.payload;
    },
    selectedQuestionDirection: (state, action) => {
      state.selectedQuestionDirection = action.payload;
    },
    selectedQuestionSubQKeys: (state, action) => {
      state.selectedQuestionSubQKeys = action.payload;
    },
    setFilteredResponses: (state, action) => {
      state.filteredResponses = action.payload;
    },
    setSelectedQuestionV: (state, action) => {
      state.selectedQuestionV = action.payload;
    },
    setSelectedNote: (state, action) => {
      state.selectedNote = action.payload;
    },
    selectedQuestionTotalResponses: (state, action) => {
      state.totalQuestionResponses = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setHasResponse: (state, action) => {
      state.hasResponse = action.payload;
    },
  },
});

export const {
  selectedQuestion,
  selectedQuestionNumber,
  selectedQuestionSubQKeys,
  selectedQuestionDirection,
  selectedQuestionSubquestions,
  selectedQuestionSubquestionsNumber,
  selectedQuestionResponses,
  setFilteredResponses,
  setSelectedQuestionV,
  setSelectedNote,
  selectedQuestionTotalResponses,
  setIsLoading,
  setHasResponse,
} = questionsSlice.actions;

export default questionsSlice.reducer;
